"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UnsupportedVersionError extends Error {
    constructor(version, message) {
        super(`Unsupported version: ${version}, message: ${message}`);
        this.version = version;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}
exports.default = UnsupportedVersionError;
//# sourceMappingURL=UnsupportedVersionError.js.map